import React from 'react';
import Customer from './Customer';
import CustomerCard from './CustomerCard';
import ListGroup from 'react-bootstrap/ListGroup';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Accordion from 'react-bootstrap/Accordion';


class Customers extends React.Component {

  constructor(props) {
    super(props);
    this.state = {collapsed: false}
  }

  componentDidMount() {
    this.props.loadCustomers();
  }

  handleSearchChange = (e) => {
    e.preventDefault();
    let form = e.target;

    var searchString = form.value;

    const { filterCustomers } = this.props;
    filterCustomers(searchString);
  }

  render() {
    return (
      <div className="mt-3">
        <CustomerCard selectedCustomer={this.props.selectedCustomer}
          subscriptions={this.props.subscriptions}
          appointments={this.props.appointments}
          clearSelectedCustomer={this.props.clearSelectedCustomer}
          deleteCustomer={this.props.deleteCustomer} />

        <Accordion className="mt-3 customers-accordion" defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              Customers
            </Accordion.Header>
            <Accordion.Body className="px-0 pt-2">
              <Form inline="true">
                <FormControl className="w-100" id="customerSearch" type="text" placeholder="Search" onChange={this.handleSearchChange} />
              </Form>

              <ListGroup className="mt-1">
                {this.props.customers.map((customer, index) =>
                  <Customer key={index} customer={customer} selectCustomer={this.props.selectCustomer} />
                )}
              </ListGroup>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    );
  }
}

export default Customers;
